
import { Component, Vue } from 'vue-property-decorator';
import PYCModel from '@/types/pycModel';
import DropdownRow from '../shared/DropdownRow.vue';
import InputRow from '../shared/InputRow.vue';
import InlineAlert from '../shared/InlineAlert.vue';
import { ClientConstants } from '../../client.constants';
import moment from 'moment-business-days';
import { isHoliday } from '../../holidays';

@Component({
    components: {
        DropdownRow,
        InputRow,
        InlineAlert,
    },
})
export default class SelectionBlock extends Vue {
    clientConstants = ClientConstants;

    ENUM_YIELDPRICE = {
        YIELD: 'YIELD',
        PRICE: 'PRICE',
    };

    pycmodel: PYCModel = {
        calculateType: this.ENUM_YIELDPRICE.YIELD,
        bondType: 'Corporate',
        purchasePrice: '',
        yieldToMaturityOrCall: '',
        annualCouponRate: '',
        couponFrequency: '2',
        maturityDate: '',
        callDate: '',
        callPrice: '',
        parValue: '1000.00',
        quantity: '',
        settlementDate: '',
        commissionFee: '',
    };
    settlementDateIsInValid = false;
    callDateIsInValid = false;
    callPriceIsNotPresent = false;
    callDateIsNotPresent = false;

    get defaultSettlementDate(): string {
        // using Date.now() to initialize the default date allows mocking the date in unit tests
        let defaultDate = new Date(Date.now());
        const additionalDays = 1
        defaultDate = moment(defaultDate).businessAdd(additionalDays).toDate();

        if (isHoliday(defaultDate)) {
            defaultDate = moment(defaultDate).businessAdd(1).toDate();
        }

        return moment(defaultDate).format('YYYY-MM-DD');
    }

    created() {
        this.pycmodel.settlementDate = this.defaultSettlementDate;
    }

    onSelectCalculationType(value: any) {
        this.pycmodel.calculateType = value;
        this.$emit('changeType', value);
        this.resetFields();
    }

    onSelectBondType(value: any) {
        this.pycmodel.bondType = value;
        // reset the settlement date based on the newly selected bond type
        this.pycmodel.settlementDate = this.defaultSettlementDate;
    }

    onSelectCouponFrequency(value: any) {
        this.pycmodel.couponFrequency = value;
    }

    onSelectParValue(value: any) {
        this.pycmodel.parValue = value;
    }

    onReset(): void {
        this.pycmodel.calculateType = this.ENUM_YIELDPRICE.YIELD;
        this.resetFields();
        this.$emit('changeType', this.ENUM_YIELDPRICE.YIELD)
    }

    resetFields(): void {
        this.pycmodel.bondType = 'Corporate';
        this.pycmodel.purchasePrice = '';
        this.pycmodel.yieldToMaturityOrCall = '';
        this.pycmodel.annualCouponRate = '';
        this.pycmodel.couponFrequency = '2';
        this.pycmodel.maturityDate = '';
        this.pycmodel.callDate = '';
        this.pycmodel.callPrice = '';
        this.pycmodel.parValue = '1000.00';
        this.pycmodel.quantity = '';
        this.pycmodel.settlementDate = this.defaultSettlementDate;
        this.pycmodel.commissionFee = '';

        this.settlementDateIsInValid = false;
        this.callDateIsInValid = false;
        this.callPriceIsNotPresent = false;
        this.callDateIsNotPresent = false;

        this.$root.$emit('resetFields');
        this.$root.$emit('resetChart');
    }

    onFormSubmit(/* event: any */) {
        if (!(this.settlementDateIsInValid || this.callDateIsInValid || this.callPriceIsNotPresent || this.callDateIsNotPresent)) {
            this.$root.$emit(
                'getYieldPriceData',
                JSON.stringify(this.pycmodel)
            );
        } else {
            //TODO: move focus to the error
        }
    }

    doDateValidation() {
        this.settlementDateIsInValid = false;
        this.callDateIsInValid = false;
        this.callPriceIsNotPresent = this.pycmodel.callDate !== '' && this.pycmodel.callPrice == '';
        this.callDateIsNotPresent = this.pycmodel.callDate == '' && this.pycmodel.callPrice !== '';
        if (
            this.pycmodel.settlementDate !== '' &&
            this.pycmodel.maturityDate !== ''
        ) {
            this.settlementDateIsInValid =
                this.pycmodel.maturityDate < this.pycmodel.settlementDate;
            if (this.pycmodel.callDate !== '') {
                this.callDateIsInValid =
                    this.pycmodel.callDate > this.pycmodel.maturityDate ||
                    this.pycmodel.callDate < this.pycmodel.settlementDate;
            }
        }
    }
}
